<template>
  <div class="space-y-6">
    <div v-for="(item,i) in computedLegend" :key="i" class="flex items-center">
      <div class="w-6 h-6 mr-4 rounded-full flex-none" :style="{backgroundColor:item.bg}"></div>
      <div class="text-sm text-text">{{ item.label }}</div>
    </div>
    <div v-if="legend.length > 5 && !showMore"
         @click="showMore = true"
         class="inline-block ml-10 text-text-ternary text-sm
                transition duration-200 cursor-pointer
                hover:text-red hover:border-red
                border-b border-border border-dashed border-opacity-50">
      {{ $t('showMore') }}
    </div>
  </div>
</template>

<script>
export default {
  name: "ChartLegendDisplay",
  data() {
    return {
      showMore: false
    }
  },
  props: {
    legend: {
      type: Array
    }
  },
  computed: {
    computedLegend() {
      if (this.legend.length < 5) {
        return this.legend;
      } else if (this.showMore) {
        return this.legend;
      } else {
        return this.legend.slice(0, 5)
      }
    }
  },
  watch:{
    legend(){
      this.showMore = false
    }
  },
  i18n: {
    messages: {
      en: {
        showMore: 'Show more'
      },
      ru: {
        showMore: 'Показать больше'
      }
    }
  }
}
</script>